import TimeType from "../enum/ExportType";

const TimeTypeNameMap = {
    [TimeType.ORDER_TIME]: "下单时间",

    [TimeType.PAYMENT_TIME]: "付款时间",

    [TimeType.PRINTING_TIME]: "打印时间",

    [TimeType.SHIPPING_TIME]: "发货时间",

    [TimeType.EXPORT_TIME]: "导入时间",

    [TimeType.SPECIFIED_ORDER]: "勾选订单",

    [TimeType.SPECIFIED_QUERY]: "查询订单导出",
};

export default TimeTypeNameMap;
